/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ShowManagementCreateShowRequest } from '../models/ShowManagementCreateShowRequest';
import type { ShowManagementCreateShowResponseApiRespoonse } from '../models/ShowManagementCreateShowResponseApiRespoonse';
import type { ShowManagementDeleteShowRequest } from '../models/ShowManagementDeleteShowRequest';
import type { ShowManagementDeleteShowResponseApiRespoonse } from '../models/ShowManagementDeleteShowResponseApiRespoonse';
import type { ShowManagementEditShowRequest } from '../models/ShowManagementEditShowRequest';
import type { ShowManagementEditShowResponseApiRespoonse } from '../models/ShowManagementEditShowResponseApiRespoonse';
import type { ShowManagementListSearchRequest } from '../models/ShowManagementListSearchRequest';
import type { ShowManagementListSearchResponseApiRespoonse } from '../models/ShowManagementListSearchResponseApiRespoonse';
import type { ShowManagementListShowForSelectRequest } from '../models/ShowManagementListShowForSelectRequest';
import type { ShowManagementListShowForSelectResponseApiRespoonse } from '../models/ShowManagementListShowForSelectResponseApiRespoonse';
import type { ShowManagementListShowRequest } from '../models/ShowManagementListShowRequest';
import type { ShowManagementListShowResponseApiRespoonse } from '../models/ShowManagementListShowResponseApiRespoonse';
import type { ShowManagementShowShowRequest } from '../models/ShowManagementShowShowRequest';
import type { ShowManagementShowShowResponseApiRespoonse } from '../models/ShowManagementShowShowResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ShowManagementService {

    /**
     * list show
     * @param requestBody
     * @returns ShowManagementListShowResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminShow(
        requestBody: ShowManagementListShowRequest,
    ): CancelablePromise<ShowManagementListShowResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/show',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * create show
     * @param requestBody
     * @returns ShowManagementCreateShowResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminShowCreate(
        requestBody: ShowManagementCreateShowRequest,
    ): CancelablePromise<ShowManagementCreateShowResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/show/create',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * get show info
     * @param requestBody
     * @returns ShowManagementShowShowResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminShowShow(
        requestBody: ShowManagementShowShowRequest,
    ): CancelablePromise<ShowManagementShowShowResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/show/show',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * update show
     * @param requestBody
     * @returns ShowManagementEditShowResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminShowEdit(
        requestBody: ShowManagementEditShowRequest,
    ): CancelablePromise<ShowManagementEditShowResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/admin/show/edit',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * delete show
     * @param requestBody
     * @returns ShowManagementDeleteShowResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminShowDelete(
        requestBody: ShowManagementDeleteShowRequest,
    ): CancelablePromise<ShowManagementDeleteShowResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/show/delete',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * get list search params
     * @param requestBody
     * @returns ShowManagementListSearchResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminShowListSearchParams(
        requestBody: ShowManagementListSearchRequest,
    ): CancelablePromise<ShowManagementListSearchResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/show/list-search-params',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * list show for select box
     * @param requestBody
     * @returns ShowManagementListShowForSelectResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminShowListForSelect(
        requestBody: ShowManagementListShowForSelectRequest,
    ): CancelablePromise<ShowManagementListShowForSelectResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/show/list-for-select',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
